export default __webpack_public_path__ + "static/easy-b2667277bb471b769035142742ebeb0c.png";